import classNames from 'classnames';
import { FunctionComponent, PropsWithChildren } from 'react';
import FlipMove from 'react-flip-move';
import { GridProps } from './GridProps';

export const Grid: FunctionComponent<PropsWithChildren<GridProps>> = ({
  className,
  gap = '12px',
  fillStyle = 'auto-fit',
  minColumnWidth = '240px',
  maxColumnWidth = '1fr',
  animating = false,
  children
}) => {
  return animating ? (
    <FlipMove
      className="grid"
      style={{ gap: gap, gridTemplateColumns: `repeat(${fillStyle}, minmax(${minColumnWidth}, ${maxColumnWidth}))` }}
    >
      {children}
    </FlipMove>
  ) : (
    <div
      className={classNames('grid', className)}
      style={{ gap: gap, gridTemplateColumns: `repeat(${fillStyle}, minmax(${minColumnWidth}, ${maxColumnWidth}))` }}
    >
      {children}
    </div>
  );
};
